import { getAirportCode } from './location.utils';
import i18n from 'i18next';
import moment from 'moment';
import { AAServiceTypes, searchSubTypeToAirRequestTypeMap } from '../constants/Enums';
const today = moment(new Date());
const todayString = today.format('YYYY-MM-DD');
const currentHour = today.format('HH');
let pickUpTime;
let dropOffTime;

const setTodaysTime = () => {
  const sameDayDefault = +currentHour + 2;
  if (sameDayDefault < 24) {
    pickUpTime = sameDayDefault.toString();
  } else {
    pickUpTime = '23';
  }
  dropOffTime = '11';
};

export const initCarTimesForToday = (fromDate, hasAir) => {
  if (hasAir) {
    pickUpTime = '60';
    dropOffTime = '60';
  } else {
    if (fromDate === todayString) {
      setTodaysTime();
    }
  }
  return {
    pickUpTime,
    dropOffTime,
  };
};

//values for option maps are translation keys
export const airOptionMap = {
  roundtrip: 'AirRoundTripOption',
  oneway: 'AirOneWayOption',
  // multicity: 'AirMultiCityOption',//hiding temporarily
};

export const hotelOptionMap = {
  oneway: 'HotelOneWayOption',
  // multicity: 'HotelMultiCityOption',
};

export const carOptionMap = {
  roundtrip: 'CarRoundTripOption',
  oneway: 'CarOneWayOption',
};

export const railOptionMap = {
  roundtrip: 'AirRoundTripOption',
  oneway: 'AirOneWayOption',
};

export const getDominantSearchType = (hasAir, hasHotel, hasCar, hasRail) => {
  if (hasRail) {
    return 'rail';
  }
  if (hasAir) {
    return 'air';
  }
  if (hasHotel) {
    return 'hotel';
  }
  if (hasCar) {
    return 'car';
  }
  return '';
};

export const validateAuthNumber = (searchInputState) => {
  const { serviceType, authNumber } = searchInputState;
  if (isBXservice(serviceType) && authNumber.trim() === '') {
    return { msg: 'You must fill the Auth Number', isFailed: true };
  }
  return { isFailed: false };
};

export const isBXservice = (serviceType) => {
  return serviceType === AAServiceTypes.BUSINESS_EXTRA.text;
};

export const validateTripSearch = (searchModel) => {
  const msgMoreInfo1 = i18n.t('common:ValidateTripSearch.msgMoreInfo1');
  const msgMoreInfo2 = i18n.t('common:ValidateTripSearch.msgMoreInfo2');
  const msgMoreInfo3 = i18n.t('common:ValidateTripSearch.msgMoreInfo3');
  const msgAirport2 = i18n.t('common:ValidateTripSearch.msgAirport2');
  const msgTraveler1 = i18n.t('common:ValidateTripSearch.msgTraveler1');
  const msgTraveler2 = i18n.t('common:ValidateTripSearch.msgTraveler2');
  const msgTraveler3 = i18n.t('common:ValidateTripSearch.msgTraveler3');
  const msgTraveler4 = i18n.t('common:ValidateTripSearch.msgTraveler4');
  const msgHotel1 = i18n.t('common:ValidateTripSearch.msgHotel1');
  const msgHotel2 = i18n.t('common:ValidateTripSearch.msgHotel2');

  let isFailed = false;
  let msg = msgMoreInfo2;

  const dominantSearchType = getDominantSearchType(
    searchModel.hasAir,
    searchModel.hasHotel,
    searchModel.hasCar,
    searchModel.hasRail
  );

  const noOfAdult = searchModel.adultCount;
  const noOfSenior = searchModel.seniorCount || 0;
  const noOfChild = searchModel.childCount || 0;
  const noOfInfant = 0;

  if (searchModel.searchCriteria.length > 1) {
    for (let index = 0; index < searchModel.searchCriteria.length; index++) {
      if (index > 0) {
        if (
          searchModel.searchCriteria[index].fromDate <
          searchModel.searchCriteria[index - 1].fromDate
        ) {
          return { isFailed: true, msg: msgMoreInfo3 };
        }
      }
    }
  }

  const noOfAirTraveler = parseInt(noOfAdult + noOfSenior + noOfChild);
  const noOfAdultSenior = parseInt(noOfAdult + noOfSenior);

  if (!searchModel.hasAir && !searchModel.hasHotel && !searchModel.hasCar && !searchModel.hasRail) {
    return { isFailed: true, msg: msgMoreInfo1 };
  } else if (noOfAirTraveler > 6) {
    msg = msgTraveler1;
    isFailed = true;
  } else if (noOfAirTraveler === 0) {
    msg = msgTraveler2;
    isFailed = true;
  } else if (noOfChild > 0 && noOfAdultSenior === 0) {
    msg = msgTraveler3;
    isFailed = true;
  } else if (noOfInfant > noOfAdultSenior && searchModel.hasAir) {
    msg = msgTraveler4;
    isFailed = true;
  }

  for (let index = 0; index < searchModel.searchCriteria.length; index++) {
    const criteria = searchModel.searchCriteria[index];
    //multi city checks
    if (searchModel.searchCriteria.length > 1) {
      if (searchModel.hasAir) {
        const missingMultiCityAirData =
          !criteria.fromCity || !criteria.toCity || !criteria.fromDate;
        if (missingMultiCityAirData) {
          return { isFailed: true, msg: msgMoreInfo2 };
        }
      } else if (searchModel.hasHotel) {
        const missingMultiCityHotelData =
          !criteria.toCity || !criteria.fromDate || !criteria.toDate;
        if (missingMultiCityHotelData) {
          return { isFailed: true, msg: msgMoreInfo2 };
        }
      }
    } else {
      if (!criteria.toCity) {
        return { isFailed: true, msg: msgMoreInfo2 };
      }

      if (dominantSearchType !== 'hotel' && !criteria.fromCity) {
        return { isFailed: true, msg: msgMoreInfo2 };
      }

      if (
        searchModel.airRequestType === 1 &&
        (searchModel.hasRail ||
          (searchModel.hasAir && !(searchModel.hasCar || searchModel.hasHotel)))
      ) {
        if (!criteria.fromDate) {
          return { isFailed: true, msg: msgMoreInfo2 };
        }
      } else {
        if (!criteria.toDate || !criteria.fromDate) {
          return { isFailed: true, msg: msgMoreInfo2 };
        }
      }
    }

    if (searchModel.hasAir && isSameAirports(criteria.fromCity, criteria.toCity)) {
      return { isFailed: true, msg: msgAirport2 };
    }

    if (searchModel.hasHotel) {
      // 28 days hotel limit

      const dep = Date.parse(criteria.fromDate);
      const arr = Date.parse(criteria.toDate);

      const days = (arr - dep) / 1000 / 60 / 60 / 24;
      if (days > 28) {
        return { isFailed: true, msg: msgHotel1 };
      }
    }
  }

  if (searchModel.noofRooms > noOfAirTraveler) {
    msg = msgHotel2;
    isFailed = true;
  }

  if (isFailed) {
    return { isFailed: true, message: msg };
  } else {
    return { isFailed: false };
  }
};

export const isSameAirports = (airport1, airport2) => {
  if (airport1 && airport2) {
    const str_airport1 = getAirportCode(airport1);
    const str_airport2 = getAirportCode(airport2);

    if (str_airport1.toUpperCase() == str_airport2.toUpperCase()) {
      return true;
    }
  }
  return false;
};

export const searchStatus = {
  INCOMPLETE: 'INCOMPLETE',
  COMPLETE: 'COMPLETE',
  PARTIAL: 'PARTIAL',
  CANCELED: 'CANCELED',
};

export const evaluateSearch = ({
  isFirstAttempt,
  newResults,
  attempts,
  initialResults,
  currentResults,
}) => {
  if (!isFirstAttempt) {
    const isTempDataValid = Array.isArray(newResults);
    const isCurrentSearchValid = Array.isArray(currentResults);
    if (attempts > 0) {
      if (!isTempDataValid || (isCurrentSearchValid && currentResults.length > newResults.length)) {
        return searchStatus.INCOMPLETE;
      }
    }

    if (isTempDataValid && isCurrentSearchValid) {
      if (currentResults.length <= newResults.length) {
        return searchStatus.COMPLETE;
      }
      if (currentResults.length <= initialResults.length) {
        return searchStatus.CANCELED;
      }
    } else {
      return searchStatus.CANCELED;
    }
  }
  return searchStatus.PARTIAL;
};

export const getAge = (birthday) => {
  const today = new Date();
  const birthDate = new Date(birthday);
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};

export const isOneWayTrip = (airRequestType) => {
  return airRequestType === searchSubTypeToAirRequestTypeMap.oneway;
};

export const isRoundTrip = (airRequestType) => {
  return airRequestType === searchSubTypeToAirRequestTypeMap.roundtrip;
};
